import * as d3 from "d3";
import $ from 'jquery';
import { saveAs } from 'file-saver';

function addCommas(x) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}
function addPlus(x) {
    if (x > 0) { return '+' + x }
    else { return x }
}

function downloadData(buttonID, data, filename) {

    var a = document.getElementById(buttonID);
    a.addEventListener('click', function (e) {

        var blob = new Blob([d3.csvFormat(data)],
            { type: "text/csv;charset=utf-8" });
        saveAs(blob, filename);
    })
}

function genderTooltip() {
    d3.selectAll('.genderTooltipIndicator')
        .on("mouseover", function () {
            var tooltip_str = "Estas categorías de género/sexo se presentan como aparecen en la fuente de datos del LASD. “Hombres” y “mujeres” son las únicas dos categorías incluidas en esos datos. Consulte “Sobre los datos” para obtener más información."
            tooltip.html(tooltip_str)
                .style("visibility", "visible");
        })
        .on("mousemove", function () {
            tooltip.style("top", event.pageY - (tooltip.node().clientHeight - 75) + "px")
                .style("left", event.pageX - (tooltip.node().clientWidth / 2.0) + "px");
        })
        .on("mouseout", function () {
            tooltip.style("visibility", "hidden");
        })

    var tooltip = d3.select("body").append("div")
        .attr("class", "genderTooltip");
}

function raceTooltip() {
    d3.selectAll('.raceTooltipIndicator')
        .on("mouseover", function () {
            var tooltip_str = "race language"
            tooltip.html(tooltip_str)
                .style("visibility", "visible");
        })
        .on("mousemove", function () {
            tooltip.style("top", event.pageY - (tooltip.node().clientHeight - 75) + "px")
                .style("left", event.pageX - (tooltip.node().clientWidth / 2.0) + "px");
        })
        .on("mouseout", function () {
            tooltip.style("visibility", "hidden");
        })

    var tooltip = d3.select("body").append("div")
        .attr("class", "raceTooltip");
}

function mcjPopulationTooltip() {
    d3.selectAll('.populationTooltipIndicator')
        .on("mouseover", function () {
            let tooltip_str
            if ($(this).hasClass('pretrial') || $(this).hasClass('partially') || $(this).hasClass('sentenced')) { tooltip_str = "These groups can be decreased through targeted diversion, including scaling up existing strategies like court date notifications and mental health diversion programs." }
            else if ($(this).hasClass('awaiting')) { tooltip_str = "Pre-pandemic, there were around 700 people awaiting transfer to state prison on any given day. This number grew significantly in 2020 because of restrictions on transfers due to COVID-19. This estimates a return to pre-pandemic levels once transfers resume." }
            else if ($(this).hasClass('total')) { tooltip_str = "The target population for closing Men’s Central Jail is 8,200-8,500." }
            else { tooltip_str = "" }

            tooltip.html(tooltip_str)
                .style("visibility", "visible");
        })
        .on("mousemove", function () {
            tooltip.style("top", event.pageY - (tooltip.node().clientHeight - 75) + "px")
                .style("left", event.pageX - (tooltip.node().clientWidth / 2.0) + "px");
        })
        .on("mouseout", function () {
            tooltip.style("visibility", "hidden");
        })

    var tooltip = d3.select("body").append("div")
        .attr("class", "mcjPopTooltip");
}

export { addCommas, addPlus, downloadData, genderTooltip, raceTooltip, mcjPopulationTooltip }